import React, { useContext, useMemo, useState } from "react";

interface DashboardWidgets {
  showNews: boolean;
  showDriverDownloadStatus: boolean;
  showVehicleDownloadStatus: boolean;
  showCompanyCards: boolean;
  showDeviceStatus: boolean;
  showConnectivityStatus: boolean;
  showCredits: boolean;
  showCCstatus: boolean;
  showCCExpiration: boolean;
}

interface DashboardContextType {
  dashboardWidgets: DashboardWidgets;
  setDashboardWidgets: React.Dispatch<React.SetStateAction<DashboardWidgets>>;
}

export const DashboardContext = React.createContext<
  DashboardContextType | undefined
>(undefined);

interface DashboardProviderProps {
  children?: React.ReactNode;
}

const DashboardProvider = ({ children }: DashboardProviderProps) => {
  // use state to manage dashboard widgets api calls on refreshDashboardData function call.
  const [dashboardWidgets, setDashboardWidgets] = useState<DashboardWidgets>({
    showNews: false,
    showVehicleDownloadStatus: true,
    showDriverDownloadStatus: true,
    showDeviceStatus: true,
    showCompanyCards: false,
    showConnectivityStatus: false,
    showCredits: false,
    showCCstatus: false,
    showCCExpiration: false
  }); // default to true, if it's a core widget

  const contextValue = useMemo(
    () => ({
      dashboardWidgets,
      setDashboardWidgets
    }),
    [dashboardWidgets]
  );

  return (
    <DashboardContext.Provider value={contextValue}>
      {children}
    </DashboardContext.Provider>
  );
};

export const useDashboardContext = () => {
  const context = useContext(DashboardContext);
  if (!context) {
    throw new Error(
      "useDashboardContext must be used within a DashboardProvider"
    );
  }
  return context;
};

export default DashboardProvider;
